/**
 * @generated SignedSource<<a0ebb8d8acec11cee7a19676551fb605>>
 * @relayHash d0192e9027c3164ba3b2a755337a3375
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8da781eaad1cd0ab24a2296e2a299e443ff557c07b573ab6c4e0c504a7d44464

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import simplifiedTimeTracking_provider from '@atlassian/jira-relay-provider/src/simplified-time-tracking.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8da781eaad1cd0ab24a2296e2a299e443ff557c07b573ab6c4e0c504a7d44464",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": simplifiedTimeTracking_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider
    }
  }
};

export default node;
